module.exports = __webpack_public_path__ + "img/carshina22_15.272be4e4.jpg";